export default __webpack_public_path__ + "static/media/insta05.64b79baa.webp";